import { render, staticRenderFns } from "./Biometry.vue?vue&type=template&id=375f2bcb&scoped=true&"
import script from "./Biometry.vue?vue&type=script&lang=js&"
export * from "./Biometry.vue?vue&type=script&lang=js&"
import style0 from "./Biometry.vue?vue&type=style&index=0&id=375f2bcb&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375f2bcb",
  null
  
)

export default component.exports